import { MutationTree } from 'vuex';
import { State } from './state';
import { GeneralMutationTypes } from './mutation-types';
import {
  UserHierarchyApiResponse,
  EtlInfoApiResponse,
  UserPreferencesResponse,
  LeadDataResolutionMap,
} from './types';
import { Banker } from '../leads/types';

export type Mutations<S = State> = {
  [GeneralMutationTypes.SET_USER_HIERARCHY](
    state: S,
    payload: {
      userHierarchy: UserHierarchyApiResponse;
    }
  ): void;
  [GeneralMutationTypes.SET_META_DATA](
    state: S,
    payload: {
      metaTeams: Array<string>;
      metaCountries: Array<string>;
      metaMarkets: Array<string>;
    }
  ): void;
  [GeneralMutationTypes.SET_ETL_DATA](
    state: S,
    payload: { etlInfo: EtlInfoApiResponse }
  ): void;
  [GeneralMutationTypes.SET_SHOW_SESSION_MODAL](
    state: S,
    payload: { showSessionModal: boolean }
  ): void;
  [GeneralMutationTypes.SET_USER_PREFERENCES](
    state: S,
    payload: {
      userPreferences: UserPreferencesResponse;
    }
  ): void;
  [GeneralMutationTypes.SET_CLIENT_NAME_RESOLUTION_MAP](
    state: S,
    payload: { [key: string]: string }
  ): void;
  [GeneralMutationTypes.SET_CLIENT_NAME_RESOLUTION_LOADING](
    state: S,
    payload: boolean
  ): void;
  [GeneralMutationTypes.SET_CONTAINER_NAME_RESOLUTION_MAP](
    state: S,
    payload: { [key: string]: string }
  ): void;
  [GeneralMutationTypes.SET_CONTAINER_NAME_RESOLUTION_LOADING](
    state: S,
    payload: boolean
  ): void;
  [GeneralMutationTypes.SET_COLLECTION_NAME_RESOLUTION_MAP](
    state: S,
    payload: { [key: string]: string }
  ): void;
  [GeneralMutationTypes.SET_COLLECTION_NAME_RESOLUTION_LOADING](
    state: S,
    payload: boolean
  ): void;
  [GeneralMutationTypes.SET_LEAD_DATA_RESOLUTION_MAP](
    state: S,
    payload: LeadDataResolutionMap
  ): void;
  [GeneralMutationTypes.SET_LEAD_DATA_RESOLUTION_LOADING](
    state: S,
    payload: boolean
  ): void;
  [GeneralMutationTypes.SET_BANKER_NAME_RESOLUTION_MAP](
    state: S,
    payload: Array<Banker>
  ): void;
  [GeneralMutationTypes.SET_BANKER_NAME_RESOLUTION_LOADING](
    state: S,
    payload: boolean
  ): void;
  [GeneralMutationTypes.RESET_COLLECTION_CONTAINER_NAME_RESOLUTION](
    state: S
  ): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [GeneralMutationTypes.SET_USER_HIERARCHY](
    state: State,
    payload: {
      userHierarchy: UserHierarchyApiResponse;
    }
  ) {
    state.userHierarchy = payload.userHierarchy;
  },
  [GeneralMutationTypes.SET_META_DATA](state: State, payload) {
    state.metaTeams = payload.metaTeams;
    state.metaCountries = payload.metaCountries;
    state.metaMarkets = payload.metaMarkets;
  },
  [GeneralMutationTypes.SET_ETL_DATA](state: State, payload) {
    state.etl = payload.etlInfo;
  },
  [GeneralMutationTypes.SET_SHOW_SESSION_MODAL](state: State, payload) {
    state.showSessionModal = payload.showSessionModal;
  },
  [GeneralMutationTypes.SET_USER_PREFERENCES](state: State, payload) {
    state.userPreferences = payload.userPreferences;
  },
  [GeneralMutationTypes.SET_CLIENT_NAME_RESOLUTION_MAP](state, payload) {
    state.clientNameResolutionMap = payload;
  },
  [GeneralMutationTypes.SET_CLIENT_NAME_RESOLUTION_LOADING](state, payload) {
    state.clientNameResolutionLoading = payload;
  },
  [GeneralMutationTypes.SET_CONTAINER_NAME_RESOLUTION_MAP](state, payload) {
    state.containerNameResolutionMap = payload;
  },
  [GeneralMutationTypes.SET_CONTAINER_NAME_RESOLUTION_LOADING](state, payload) {
    state.containerNameResolutionLoading = payload;
  },
  [GeneralMutationTypes.SET_COLLECTION_NAME_RESOLUTION_MAP](state, payload) {
    state.collectionNameResolutionMap = payload;
  },
  [GeneralMutationTypes.SET_COLLECTION_NAME_RESOLUTION_LOADING](
    state,
    payload
  ) {
    state.collectionNameResolutionLoading = payload;
  },
  [GeneralMutationTypes.RESET_COLLECTION_CONTAINER_NAME_RESOLUTION](state) {
    state.collectionNameResolutionMap = {};
    state.containerNameResolutionMap = {};
  },
  [GeneralMutationTypes.SET_LEAD_DATA_RESOLUTION_MAP](state, payload) {
    state.leadsDataResolutionMap = payload;
  },
  [GeneralMutationTypes.SET_BANKER_NAME_RESOLUTION_MAP](state, payload) {
    state.bankerNameResolutionMap = payload;
  },
  [GeneralMutationTypes.SET_BANKER_NAME_RESOLUTION_LOADING](state, payload) {
    state.bankerNameResolutionLoading = payload;
  },
  [GeneralMutationTypes.SET_LEAD_DATA_RESOLUTION_LOADING](state, payload) {
    state.leadsDataResolutionLoading = payload;
  },
};
